import React, { useEffect, useState, useContext } from 'react';
import { HrActionText, HrFlexContainer, HrPrimary, HrRed, HrRedHover } from '@components/styles/hr-styles';
import { SelectForm } from '@components/form/select/select';
import { find, isEqual, sortBy, intersectionWith } from 'lodash';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { _language, _nivelLanguage } from '../../../constant/vacancy';
import { DisplaySettingsContext } from '../../store/display-settings';

const FlexContainer = styled(HrFlexContainer)`
  flex-direction: column;
  align-items: flex-end;
  padding: 0 32px;
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;
const Flex = styled(HrFlexContainer)`
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

const Addbutton = styled(HrActionText)`
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px`};
  color: ${HrPrimary};
  margin-left: 32px !important;
  @media (max-width: 768px) {
    margin-left: 16px !important;
  }
`;

const languageDefault = {
  language: null,
  oralLevel: null,
  writtenLevel: null
};

export const SectionLanguage = ({
  requiredLanguage,
  getValues,
  setValue,
  unregister,
  vacancy,
  control,
  formState,
  postulant,
  action
}) => {
  const [t] = useTranslation();
  const [language, setLanguage] = useState([]);
  const { languages } = postulant;
  const { req_idioma = [] } = vacancy;
  const reqIdioma = req_idioma[0] || '';
  useEffect(() => {
    const langEdu = postulant.languages ?? [];
    let currentLangueges = [];
    currentLangueges = action !== 'edit' ? getValues('languages') || [] : [];
    const filterDataEmpty = currentLangueges.filter((educ) => {
      return !isEqual(educ, languageDefault);
    });
    if (filterDataEmpty.length === 0) {
      currentLangueges = [];
    }
    const _languages = langEdu;
    currentLangueges.forEach((lang) => {
      if (!find(langEdu, { language: lang.language })) {
        _languages.push({
          language: lang.language,
          oralLevel: lang.oralLevel,
          writtenLevel: lang.writtenLevel
        });
      }
    });

    // _languages = sortBy(_languages, (l) => {
    //   return l.language === reqIdioma;
    // });
    const langs = _languages.map((e, index) => {
      Object.keys(e).forEach((key) => {
        setValue(`languages.${index}.${key}`, e[key]);
      });
      return {
        position: index,
        delete: !(requiredLanguage && e.language === reqIdioma),
        reqIdioma: e.language === reqIdioma ? reqIdioma : null
      };
    });

    if ((langs.length === 0 || !find(_languages, { language: reqIdioma })) && requiredLanguage) {
      setLanguage([{ position: 0, delete: false, reqIdioma }]);
    } else {
      setLanguage(langs);
    }
  }, [languages]);

  const handleAddLanguage = () => {
    const cloneitems = JSON.parse(JSON.stringify(language));
    cloneitems.push({ position: language.length || 0, delete: true });
    setLanguage(cloneitems);
  };

  const handleDeleteLanguage = (position) => {
    const cloneitems = language.filter((d, index) => {
      return index !== position;
    });

    let lang = getValues('languages') || [];

    unregister(`languages`);

    lang = lang.filter((d, index) => {
      return position !== index;
    });
    lang.forEach((e, index) => {
      Object.keys(e).forEach((key) => {
        const _data = e[key];
        if (_data) {
          setValue(`languages.${index}.${key}`, _data);
        }
      });
    });
    setLanguage(cloneitems);
  };
  const { fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <>
      {language &&
        language.map((e, index) => {
          return (
            <FlexContainer key={`lang_${index * 1}`}>
              <Flex flexWrap='nowrap'>
                <SelectForm
                  title={t('postulant.language.language')}
                  id={`languages.${index * 1}.language`}
                  data={_language}
                  defaultValue={reqIdioma === e.reqIdioma ? e.reqIdioma : null}
                  control={control}
                  formState={formState}
                  isSearchable
                  validate={{
                    required: requiredLanguage
                  }}
                  disabled={requiredLanguage && reqIdioma === e.reqIdioma}
                  errorPosition='bottom'
                  filterOption={(a) => {
                    const arr = language.map((_, index2) => {
                      return getValues(`languages.${index2}.language`);
                    });
                    return !arr.includes(a.value);
                  }}
                />
                <SelectForm
                  title={t('postulant.language.writtenLevel')}
                  id={`languages.${index * 1}.writtenLevel`}
                  data={_nivelLanguage}
                  // defaultValue={_nivelLanguage[0].value}
                  control={control}
                  formState={formState}
                  isSearchable
                  validate={{ required: requiredLanguage }}
                  errorPosition='bottom'
                />
                <SelectForm
                  title={t('postulant.language.oralLevel')}
                  id={`languages.${index * 1}.oralLevel`}
                  data={_nivelLanguage}
                  // defaultValue={_nivelLanguage[0].value}
                  control={control}
                  formState={formState}
                  isSearchable
                  validate={{ required: requiredLanguage }}
                  errorPosition='bottom'
                />
              </Flex>
              {e.delete === true && (
                <HrActionText
                  onClick={() => {
                    handleDeleteLanguage(index);
                  }}
                  color={HrRed}
                  colorHover={HrRedHover}
                  fontSize='14px'
                >
                  <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }} className='hr-Trash' color={HrRed} />
                  <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}>{t('general.button.delete')}</span>
                </HrActionText>
              )}
            </FlexContainer>
          );
        })}
      {language.length < _language.length && (
        <Addbutton fontSizeSetting={fontSizeSetting} onClick={handleAddLanguage}>
          {t('postulant.language.add')}
        </Addbutton>
      )}
    </>
  );
};
